import UsersTable from "../Pages/Users/Users_Table";
import ViewUsers from "../Pages/Users/View_Users";
import UpdataUser from "../Pages/Users/Update_User";
import CreatUser from "../Pages/Users/Create_User";

import { Navigate } from "react-router";

const role=localStorage.getItem("role")
export const UsersRoutes= [
  {
    path: 'Kunden',
    element: <UsersTable />
  }
  ,{
    path: 'Kunden/ViewUsers/:id',
    element: <ViewUsers />
  }
  ,{
    path: 'Kunden/UpdataUser/:id',
    element: role != 'manager' ? <Navigate to="/Kunden" replace /> : <UpdataUser />
  },
  {
    path: 'Kunden/CreatUser',
    element: role != 'manager' ? <Navigate to="/Kunden" replace /> : <CreatUser />
    
  }
];
